// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownContent_wrapper__WmsoG","col":"DropdownContent_col__tQgnW"};